import { createContext, useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom'

import Layout from "@/components/Layout"
import { useWindowDimensions } from '../hooks/useWindowDimensions';
const LayoutContext = createContext(null)

const LayoutProvider = ({ hideLayout, children }) => {
  const [chat, setChat] = useState(false)
  const [sidebar, setSidebar] = useState(true)
  const [body, setBody] = useState(null)
  const router = useNavigate()
  const { isMobile } = useWindowDimensions();

  const toggleChat = () => {
    chat ? closeChat() : openChat()
  }
  const toggleSidebar = () => {
    sidebar ? closeSidebar() : openSidebar()
  }
  const bodyLock = () => body?.classList.add('overflow-hidden')
  const bodyUnlock = () => body?.classList.remove('overflow-hidden')

  const openChat = () => {
    setChat(true)
    localStorage.setItem('cookie_chat_open', true)
    isMobile && bodyLock()
  }
  const closeChat = () => {
    setChat(false)
    localStorage.setItem('cookie_chat_open', false)
    isMobile && bodyUnlock()
  }

  const openSidebar = () => {
    setSidebar(true)
    localStorage.setItem('cookie_sidebar_open', true)
    isMobile && bodyLock()
  }
  const closeSidebar = () => {
    setSidebar(false)
    localStorage.setItem('cookie_sidebar_open', false)
    isMobile && bodyUnlock()
  }

  useEffect(() => {
    if (isMobile) return null
    const cookieSidebar = localStorage.getItem('cookie_sidebar_open')
    const cookieChat = localStorage.getItem('cookie_chat_open')

    setChat(cookieChat === "true" ? true : false)
    if (!cookieSidebar) {
      setSidebar(true)
    } else {
      setSidebar(cookieSidebar === "true" ? true : false)
    }
  }, [])

  useEffect(() => {
    if (body) return null
    setBody(document.querySelector('body'))
  },[])

  useEffect(() => {
    isMobile && closeSidebar()
  }, [router])

  return (<LayoutContext.Provider value={{
    chat,
    sidebar,
    toggleSidebar,
    toggleChat
  }}>
    {hideLayout ? children : <Layout chat={chat}>{children}</Layout>}
  </LayoutContext.Provider>)
}

export { LayoutProvider, LayoutContext }